module.exports = __webpack_public_path__ + "img/time.b1638b73.svg";